"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "Group"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector",
    d: "M1.86663 1.05016C1.61663 1.31683 1.49997 1.65016 1.49997 2.11683C1.49997 2.50016 1.34997 3.16683 1.16663 3.60016C0.799967 4.4335 0.833301 5.10016 1.26663 5.7835C1.4333 6.05016 1.49997 7.05016 1.5333 9.86683L1.5833 13.5835H7.49997H13.4166L13.4666 9.86683C13.5 7.05016 13.5666 6.05016 13.7333 5.7835C14.1666 5.10016 14.2 4.4335 13.8333 3.60016C13.65 3.16683 13.5 2.51683 13.5 2.1835C13.5 1.7835 13.3666 1.36683 13.15 1.10016L12.8166 0.666829H7.51663H2.21663L1.86663 1.05016ZM12.5 2.31683C12.5 2.6835 12.65 3.31683 12.8333 3.75016C13.2333 4.66683 13.15 5.1335 12.4833 5.76683C12.0666 6.16683 11.8333 6.25016 11.1666 6.25016C10.6333 6.25016 10.2666 6.15016 10.05 5.95016C9.6333 5.5835 9.3833 5.5835 8.5833 6.00016C7.76663 6.41683 7.2333 6.41683 6.41663 6.00016C5.61663 5.5835 5.36663 5.5835 4.94997 5.95016C4.7333 6.15016 4.36663 6.25016 3.8333 6.25016C3.16663 6.25016 2.9333 6.16683 2.51663 5.76683C1.84997 5.1335 1.76663 4.66683 2.16663 3.75016C2.34997 3.31683 2.49997 2.6835 2.49997 2.31683V1.66683H7.49997H12.5V2.31683ZM7.49997 7.3335C7.81663 7.31683 8.3833 7.20016 8.7333 7.0335C9.36663 6.75016 9.41663 6.75016 9.9833 7.0335C10.6333 7.36683 11.4166 7.41683 12.0666 7.16683L12.5 7.00016V9.8335V12.6668H11.8333H11.1833L11.1333 10.5335L11.0833 8.41683H8.8333H6.5833L6.5333 10.5335L6.4833 12.6668H4.49997H2.49997V9.8335V7.00016L2.9333 7.16683C3.56663 7.41683 4.34997 7.36683 4.99997 7.0335C5.54997 6.75016 5.61663 6.75016 6.24997 7.0335C6.61663 7.20016 7.1833 7.3335 7.49997 7.3335ZM10.1666 11.0002V12.6668H8.8333H7.49997V11.0002V9.3335H8.8333H10.1666V11.0002Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector_2",
    d: "M8.90012 2.5669C8.73345 3.00024 8.96678 3.3669 9.36678 3.30024C9.65012 3.2669 9.75012 3.13357 9.75012 2.83357C9.75012 2.53357 9.65012 2.40024 9.36678 2.3669C9.15012 2.33357 8.95012 2.4169 8.90012 2.5669Z",
    fill: fill
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "Vector_3",
    d: "M10.5666 2.5669C10.4 3.00024 10.6333 3.3669 11.0333 3.30024C11.3166 3.2669 11.4166 3.13357 11.4166 2.83357C11.4166 2.53357 11.3166 2.40024 11.0333 2.3669C10.8166 2.33357 10.6166 2.4169 10.5666 2.5669Z",
    fill: fill
  })));
};

exports["default"] = _default;